import { useContext } from 'react';
import { UserScopeContext } from '../contexts/UserScopeContext';

export const useUserScope = () => {
  const ctx = useContext(UserScopeContext);
  if (!ctx) throw new Error('useUserScope must be used within UserScopeProvider');
  return ctx;
};
